<template>
  <div class="container">
    <div class="container_banner">
      <img src="../../assets/image/Vehiclecar/banner2.png" />
    </div>
    <div class="originalstyle w">
      <div class="originalstyle_details">
        <div v-html="getdata.value"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getdata: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const { data: res } = await this.$ajax.get("/v1/common/info?type=" + 3);
      if (res.code == 0) {
        this.getdata = res.data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container_banner {
  width: 100%;
  height: 740px;
  img {
    width: 100%;
    height: 100%;
  }
}
.originalstyle {
  margin-top: 60px;
  .originalstyle_details {
    width: 100%;
    min-height: 300px;
  }
}
</style>
